import { useState } from "react";
import styled from "styled-components";
import { ContentBox, ContentPage, NoResults, Notice, SelectorPageStatus } from "@ficatranquilo/contabilidade.com-ui";
import { usePageHeader } from "@components/ow";
import { DECLARATION_TYPES } from "@helpers/declarations";
import { DeclarationViewModal, DeclarationsTable, declarationColumns } from "../../Common/Declarations";

// Declarações recebidas pela empresa (modelo Lista do DS OneWork). Só ADM (guard da
// rota). Só leitura: a tela não muda status nem exclui. O back não busca no texto,
// então o filtro é só o tipo.

const BREADCRUMB = [{ page: "Declarações", route: "/c/declarations" }];

const TYPE_DATA = [{ label: "Todos", value: "" }, ...DECLARATION_TYPES];

const COLUMNS = declarationColumns();

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export default function Declarations() {
  const [type, setType] = useState(TYPE_DATA[0]);
  const [viewing, setViewing] = useState(null);

  usePageHeader({ title: "Declarações", breadcrumb: BREADCRUMB });

  const query = type.value ? `type=${encodeURIComponent(type.value)}` : "";
  const clearFilters = () => setType(TYPE_DATA[0]);

  return (
    <ContentPage>
      <ContentBox>
        <Stack>
          <Notice
            $variant="gray"
            $text="Os colaboradores enviam dúvidas, sugestões, reclamações e elogios em Declarações. Nas anônimas, ninguém vê quem enviou, nem você."
          />
          <SelectorPageStatus options={TYPE_DATA} selected={type} onChange={setType} />
          <DeclarationsTable
            key={query}
            query={query}
            columns={COLUMNS}
            onOpen={setViewing}
            noResults={
              type.value ? (
                <NoResults notResultText="Nenhuma declaração encontrada" includeText="Limpar filtros" includeAction={clearFilters} />
              ) : (
                <NoResults notResultText="Nenhuma declaração por aqui" />
              )
            }
          />
        </Stack>
      </ContentBox>

      {viewing ? <DeclarationViewModal declaration={viewing} onClose={() => setViewing(null)} /> : null}
    </ContentPage>
  );
}
